<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <main class="px-0">
      <div class="container-fluid px-0">
        <form class="row g-3 mb-2">
          <div class="col-md-3">
            <label for="inputEmail4" class="form-label">景區</label>
            <select
              class="form-select form-select-sm"
              v-model="selectedScenicArea"
            >
              <!--  不顯示"秘書室"這個景區-->
              <option
                v-for="(scenicArea, i) in scenicAreaList.filter(s =>s.id != 18 )" 
                :key="i"
                :value="scenicArea"
              > 
                {{ scenicArea.name }}
              </option>
            </select>
          </div>
          <div class="col-md-9 col-sm-12 d-flex align-items-end justify-content-between">
            <button
              class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1"
              type="button"
              @click="scenicAreaInfo()"
            >
              <i class="fas fa-search"></i> 查詢
            </button>
            <controlHistory
              
              v-if="controlHistory"
              :selectedScenicAreaId="selectedScenicAreaId"
            ></controlHistory>
          </div>
        </form>

        <weatherInfo
          v-if="weatherInfo"
          :selectedScenicAreaId="selectedScenicAreaId"
        ></weatherInfo>
        <parkingAreaLimit
            v-if="parkingAreaLimit && selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
          ></parkingAreaLimit>

       <!-- <humanSensor
            v-if="humanSensor && selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
        ></humanSensor> -->
   

        <div
          class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2 mb-2"
        > 
          <!-- 目前僅有三仙台、石梯坪景區有公廁維運事件 -->
      
        <!-- <parkingAreaLimit
            v-if="parkingAreaLimit && selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
          ></parkingAreaLimit> -->
          <trafficFlowPerHour
            v-if="trafficFlowPerHour &&  selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
          ></trafficFlowPerHour>
          <carFlowtoPeopleFlow
            v-if="carFlowtoPeopleFlow && selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
          ></carFlowtoPeopleFlow>
          <centerPeopleFlow
            v-if="centerPeopleFlow && selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
          ></centerPeopleFlow>
          <centerPeopleGender
            v-if="centerPeopleGender && selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
          ></centerPeopleGender>
          <peopleAttributeAge
            v-if="peopleAttributeAge && selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
          ></peopleAttributeAge>
          <toiletPeopleCount
            v-if="toiletPeopleCount && selectedScenicAreaId !==null"
            :selectedScenicAreaId="selectedScenicAreaId"
          ></toiletPeopleCount>
          <!-- <iotEvent v-if="selectedScenicAreaId === 1|| selectedScenicAreaId === 3"
           :selectedScenicAreaId="selectedScenicAreaId">
          </iotEvent> -->
        </div>
        <div class="row row-cols-1 g-2 mb-2">
          <emergencyEvent
            :selectedScenicAreaId="selectedScenicAreaId"
          ></emergencyEvent>
        </div>

        <div class="row row-cols-1 g-2">
          <deviceMap :selectedScenicAreaId="selectedScenicAreaId"></deviceMap>
        </div>

        <div class="row row-cols-1 g-2 mb-2">
          <streaming :selectedScenicAreaId="selectedScenicAreaId"></streaming>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import { mapState, mapGetters } from "vuex";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";

import weatherInfo from "./weatherInfo";
import parkingAreaLimit from "./parkingAreaLimit";
import trafficFlowPerHour from "./trafficFlowPerHour";
import carFlowtoPeopleFlow from "./carFlowtoPeopleFlow";
import centerPeopleGender from "./centerPeopleGender";

import centerPeopleFlow from "./centerPeopleFlow";
import peopleAttributeAge from "./peopleAttributeAge";
import toiletPeopleCount from "./toiletPeopleCount";

import emergencyEvent from "./emergencyEvent";
import deviceMap from "./deviceMap";

import streaming from "./streaming.vue";
import controlHistory from "./controlHistory";
import humanSensor from './humanSensor.vue';
// import iotEvent from "./iotEvent.vue";

export default {
  components: {
    weatherInfo,
    parkingAreaLimit,
    trafficFlowPerHour,
    carFlowtoPeopleFlow,
    centerPeopleGender,
    centerPeopleFlow,
    peopleAttributeAge,
    emergencyEvent,
    toiletPeopleCount,
    streaming,
    controlHistory,
    deviceMap,
    humanSensor,
    // iotEvent
  },

  data() {
    return {
      dataInterval: null,
      scenicAreaList: [],
      selectedScenicArea: null,
      selectedScenicAreaId: null,

      weatherInfo: false,
      controlHistory: false,
      parkingAreaLimit: true,
      trafficFlowPerHour: true,
      carFlowtoPeopleFlow: true,
      centerPeopleGender: true,

      centerPeopleFlow: true,
      peopleAttributeAge: true,
      emergencyEvent: true,
      toiletPeopleCount: false,
      humanSensor: false,

      startTime:moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
      // endTime: moment().startOf('minute'),
      endTime: moment().format('YYYY-MM-DD HH:mm:ss'),


      //  測試非空值時間資料 (上機前須更改)
      // startTime: "2022-12-17T00:55:55",
      // endTime: "2022-12-17T23:55:55",

      // startTime: "2024-01-25T00:00+08:00",
      // endTime: "2024-01-25T23:59+08:00",

      // startTime: "2023-09-11T00:00:00",
      // endTime: "2023-09-11T23:59:00",

      // startTime: "2022-07-10T00:00:00",
      // endTime: "2023-12-21T23:59:00",
    };
  },
  // created(){
  //   this.getAllScenicArea();
  // },

  methods: {
    async getAllScenicArea() {
      this.scenicAreaList = await  this.myScenicAreaList;
    },


    async setDefaultValue() {
      this.selectedScenicArea = await this.scenicAreaList[0];
      this.selectedScenicAreaId = await this.selectedScenicArea.id;
    },

    async getVehicleAndPeople() {
      //所有景區累計人車流
      await this.$store.dispatch("elasticMonitor/getVehicleAndPeople");
      // await this.$store.dispatch(
      //   "elasticMonitor/getAllScenicAreaVehicleAndPeopleFlow"
      // );
    },

    async getAllWeather() {
      // 氣象局資料
      await this.$store.dispatch("weatherMonitor/getAllWeather");
    },

    async getDailyEmergencyEvents() {
      // 今日緊急求救事件
      const condition = {
        //緊急求救查詢條件固定為 : 永遠顯示全時段未解除事件
        startTime: "2023-12-01T00:00:00",
        // startTime: "2022-10-01T23:55:55",

        endTime: this.endTime,
        scenicAreaId: "",
        dismissStatus:2 //未解除
      };
      await this.$store.dispatch(
        "emergencyEvent/getEmergencyEvents",
        condition
      );
    },

    async getDailyDisasters() {
      // 今日天氣風險
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
      };
      await this.$store.dispatch("disasterMonitor/getAllDisaster", condition);
    },

    async getviolation() {
      //今日違規紀錄
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        scenicAreaId: this.selectedScenicAreaId,
        // type: this.selectedScenicAreaId === 3 ? 2 : 4 //三仙台查機車， 其他查封閉闖入
        // type: [2,4] //三仙台查機車， 其他查封閉闖入
        type: [] //查機車與封閉闖入



      };
      await this.$store.dispatch('violation/getViolationData', condition)
    },

    async getIotEvent(){
      //今日公廁維運事件
      //【事件總覽】洗手乳、異味偵測
      //【管制】   溫度、濕度
      const condition={
        startTime: this.startTime,
        endTime: this.endTime,
        // startTime:"2024-01-25T00:00:00+08:00",
        // endTime:"2024-01-25T23:59:59+08:00",
        // scenicAreaId: this.selectedScenicAreaId, 
      }
      await this.$store.dispatch("iotEvent/getIotEvent", condition);

    },

    async getIotData(){
      //取得公廁即時溫濕度資料
      const condition = {
        startTime: this.endTime,
        // startTime:"2023-02-28T15:24:23.447+08:00",
        scenicAreaId: this.selectedScenicAreaId,
      };
      await this.$store.dispatch("iotData/getAllIotData", condition);
    },

    async getControlHistory() {
      //今日管制紀錄
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        scenicAreaId: null,
      };
      await this.$store.dispatch('controlHistory/getControlHistoryByTimeInterval', condition)
    },

    async getParkingLimit() {
      //今日停車容留
      const condition = {
        startTime: this.startTime,
        endTime: this.endTime,
        scenicAreaId: null,
        warningLevel: CONST.PARKING_AREA_STATUS[2].status,
        passengerType:["vehicle"] //僅查詢四輪容留狀態 (小型車+大型車)
      };

      await this.$store.dispatch("parkingAvailabilityRate/getParkingAvailabilityRate", condition)
    },

    async getDeviceErrorList() {
      //今日設備異常
      const condition = {
        stTime: moment(this.startTime).format(),
        endTime: moment(this.endTime).format(),
        areaId: null,
        deviceType: "videoCamera",
        deviceStatus: -1 ,//保留 目前後端沒有用
        isNotify:true //發報僅顯示【已通報】的事件
      };

      await this.$store.dispatch("deviceError/getDeviceErrorData", condition)
    },

    async getHumanSensor(){
      const condition = {
        areaId: 0, 
      };
      await this.$store.dispatch("humanSensor/getHumanSensor", condition);
      
    },

    async getAllData() {
      this.getAllWeather();
      // this.getVehicleAndPeople();
      this.getDailyEmergencyEvents();
      this.getDailyDisasters();
      this.getviolation();
      this.getControlHistory();
      this.getIotEvent();
      // this.getIotData();
      this.getParkingLimit();
      this.getDeviceErrorList();
      // this.getHumanSensor();
    },

    async scenicAreaInfo() {
      this.selectedScenicAreaId = await this.selectedScenicArea.id;

      this.resetScenicAreaInfo();

      if (
        this.selectedScenicArea.additionInfo &
        CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW
      ) {
        // console.log("有車流");
        this.carFlowtoPeopleFlow = true;
        this.parkingAreaLimit = true;
        this.trafficFlowPerHour = true;
      }

      if (
        this.selectedScenicArea.additionInfo &
        CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE
      ) {
        // console.log("有人的影像辨識");
        this.centerPeopleGender = true;
        this.centerPeopleFlow = true;
        this.peopleAttributeAge = true;
      }

      if (
        this.selectedScenicArea.additionInfo &
        CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CLOSE_IN_ADVANCE
      ) {
        // console.log("有管制");
        this.controlHistory = true;
      }

      if (
        this.selectedScenicArea.additionInfo &
        CONST.SCENIC_AREA_ADDITION_INFO_ENUM.WEATHER_INFO
      ) {
        // console.log("有氣象");
        this.weatherInfo = true;
      }


      if (
        this.selectedScenicArea.additionInfo &
        CONST.SCENIC_AREA_ADDITION_INFO_ENUM.TOILET_PEOPLE_FLOW
      ) {
        // console.log("有廁所的人流");
        this.toiletPeopleCount = true;
      }

      if(
        this.selectedScenicArea.additionInfo &
        CONST.SCENIC_AREA_ADDITION_INFO_ENUM.HUMAN_SENSOR
      ) {
        // console.log("有停車容留");
        this.humanSensor = true;
      }
      
      // return
    },

    resetScenicAreaInfo() {
      this.controlHistory = false;
      this.weatherInfo = false;
      this.parkingAreaLimit = false;
      this.trafficFlowPerHour = false;
      this.carFlowtoPeopleFlow = false;
      this.centerPeopleGender = false;
      this.centerPeopleFlow = false;
      this.peopleAttributeAge = false;
      this.toiletPeopleCount = false;
    },
  },

  computed: {
    ...mapState("trafficFlow", { totalTrafficFlow: "totalTrafficFlow" }),
    ...mapState("elasticMonitor", { vehicleAndPeople: "vehicleAndPeople" }),
    ...mapState("weatherMonitor", { cwbWeather: "allWeather" }),
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),
  },

  watch: {
    myScenicAreaList: {
      async handler(newVal) {

        await this.getAllScenicArea();
        await this.setDefaultValue(); 
        await this.scenicAreaInfo();
        
      },
 
      
    },

    selectedScenicAreaId() {
      this.getviolation(); //違規一次只能抓一個景區， 切換景區主東呼叫api
      
    },


  },

  async mounted() {
    await this.getAllScenicArea();
    //  this.setDefaultValue();
    
    const scenicId = Utils.getParamFromURL("id");
    if (Utils.isEmptyObject(scenicId)) {
      this.selectedScenicArea = this.scenicAreaList[0];
    } else {
      this.selectedScenicArea = this.scenicAreaList.filter(
        (s) => s.id === parseInt(scenicId)
      )[0];
      this.selectedScenicAreaId = this.selectedScenicArea.id;
    }

    this.getAllData();
    await this.scenicAreaInfo();
    // await this.getAllData();

    this.dataInterval = setInterval(async () => {
      this.getAllData();
    }, CONST.REFRESH_DAT_TIMER_MIN);
  },
  destroyed() {
    if (this.dataInterval) clearInterval(this.dataInterval);
    this.dataInterval = null;
  },
};
</script>
<style lang="scss" scope>
.h5 {
  margin-bottom: 0;
  margin-top: 0;
}

.card {
  box-shadow: none;
  border: 1px boild gray;
}

.btn-success {
  border: none;
}

.btn-success:hover {
  background-color: #028d7d;
}
</style>
